export const countryStateTypes = {
  CHANGE_SELECTED_COUNTRY: 'CHANGE_SELECTED_COUNTRY'
};
